import React, { memo, ReactNode } from "react";

type Props = {
  title: string;
  children: ReactNode;
};

export const RegionInfoItem = memo(({ title, children }: Props) => {
  return (
    <div className="bg-bgLight rounded-[10px] px-2.5 py-2">
      <h4 className="text-grayDark">{title}</h4>
      {children}
    </div>
  );
});
